import React from "react";
import styles from "./STContactUs.module.css";
import clsx from "clsx";
import { STHeroCommon } from "../STHeroCommon";
import Link from "next/link";
import { Icons } from "@/const/icons";
import { STSelect } from "../STSelect";
import { STInput } from "../STInput";
import { STTextarea } from "../STTextarea";
import { STButton } from "../STButton";
import { contactUsPoster, heroBg } from "@/assets/images";
import Image from "next/image";
import { useContactUs } from "@/hooks";
export const STContactUs = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};

  const {
    formData,
    loading,
    errors,
    success,
    handleChange,
    handleSelectChange,
    handleSubmit,
  } = useContactUs();
  return (
    <>
      <STHeroCommon
        title={pageContent.title || "Contact us"}
        description={
          pageContent.description ||
          "For inquiries, collaborations, or technical discussions, please reach out to us through the details below"
        }
      />
      <section className="space-xl-py">
        <div className="container">
          <div
            className={clsx(
              styles.letsTalkWrapper,
              "d-flex flex-column flex-xl-row gap-lg",
            )}
          >
            <div
              className={clsx(styles.letsTalkContent, "w-100 text-clr-white")}
            >
              <h2 className={clsx(styles.letsTalkTitle, "primary-title")}>
                Let's talk
              </h2>

              {/* <div className="d-flex flex-column gap-md align-items-start space-md-mt">
                <STSelect
                  placeholder="I am enquiring as a"
                  options={[
                    {
                      label: "Product related challenge",
                      value: "ProductRelatedChallenge",
                    },
                    { label: "Individual", value: "individual" },
                    { label: "Business", value: "business" },
                    { label: "Investor", value: "investor" },
                  ]}
                  variant="light"
                />
                <div className="d-flex flex-column flex-sm-row gap-md w-100">
                  <STInput
                    placeholder="Enter your name"
                    variant="light"
                    className={"w-100"}
                  />

                  <STInput
                    placeholder="Enter your email address"
                    variant="light"
                    className={"w-100"}
                  />
                </div>
                <STTextarea
                  variant="light"
                  placeholder="Share your thoughts with us..."
                />
                <STButton
                  variant="black"
                  suffix={Icons.arrowRight}
                  className={styles.getInTouchBtn}
                >
                  Let's talk
                </STButton>
              </div> */}
              <div className="d-flex flex-column gap-lg align-items-start space-md-mt">
                {success && (
                  <p className="text-success mb-0">
                    Message sent successfully!
                  </p>
                )}
                <div
                  className={clsx(
                    styles.letsTalkFormTopRow,
                    "d-grid gap-md w-100",
                  )}
                >
                  <STSelect
                    placeholder="I am enquiring as a"
                    options={[
                      {
                        label: "Industry associate",
                        value: "Industry associate",
                      },
                      { label: "Investor", value: "Investor" },
                      { label: "Individual", value: "Individual" },
                    ]}
                    variant="light"
                    value={formData.type}
                    onChange={handleSelectChange}
                    error={errors.type}
                  />
                  <STInput
                    placeholder="Name"
                    variant="light"
                    className={"w-100"}
                    name="name"
                    value={formData.name}
                    handleChange={handleChange}
                    error={errors.name}
                  />

                  <STInput
                    placeholder="Email address"
                    variant="light"
                    className={"w-100"}
                    name="email"
                    value={formData.email}
                    handleChange={handleChange}
                    error={errors.email}
                  />
                </div>
                <div
                  className={clsx(
                    styles.bottomRow,
                    "d-flex gap-md w-100 align-items-start align-items-sm-center flex-column flex-sm-row",
                  )}
                >
                  <STInput
                    placeholder="Share your thoughts with us..."
                    variant="light"
                    className="w-100"
                    name="message"
                    value={formData.message}
                    handleChange={handleChange}
                    error={errors.message}
                  />

                  <STButton
                    variant="black"
                    suffix={Icons.arrowRight}
                    className={clsx(styles.getInTouchBtn, "flex-shrink-0")}
                    onClick={handleSubmit}
                    loading={loading}
                  >
                    Connect
                  </STButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="space-xl-pb">
        <div className="container">
          <div className={clsx("position-relative")}>
            <div
              className={clsx(
                styles.mediaWrapper,
                "ratio radius-xl bg-off-white overflow-hidden",
              )}
            >
              {/* <video
                className={clsx("object-fit-contain")}
                autoPlay
                loop
                muted
                playsInline
                src={"/video/contactus-video.mov"}
              /> */}
              <Image
                src={contactUsPoster}
                alt="Contact Us Banner"
                fill
                className={clsx("object-fit-cover")}
              />
            </div>

            <div
              className={clsx(
                styles.pillsWrapper,
                "position-absolute start-0 d-flex gap-xs align-items-center justify-content-center justify-content-md-between flex-wrap gap-xs w-100 z-2",
              )}
            >
              <div className={clsx("d-flex gap-xs flex-wrap")}>
                <Link
                  href="mailto:findsolution@sustanix.com"
                  className={clsx(
                    styles.contactPill,
                    "bg-clr-white gap-2 text-black p fw-medium d-flex align-items-center",
                  )}
                >
                  <span className={styles.pillIcon}>{Icons.emailIcon}</span>
                  <span className="d-none d-md-block">
                    findsolution@sustanix.com
                  </span>
                </Link>

                <Link
                  href="tel:+31643547865"
                  className={clsx(
                    styles.contactPill,
                    "bg-clr-white gap-2 text-black p fw-medium d-flex align-items-center",
                  )}
                >
                  <span className={styles.pillIcon}>{Icons.phoneIcon}</span>
                  <span className="d-none d-md-block"> +31 6 43 54 78 65</span>
                </Link>
              </div>

              <div className={clsx("d-flex gap-xs flex-wrap")}>
                <div
                  className={clsx(
                    styles.contactPill,
                    "bg-clr-white gap-2 text-black p fw-medium d-flex align-items-center",
                  )}
                >
                  <span className={clsx(styles.pillIcon, "text-clr-desire")}>
                    {Icons.pinIcon}
                  </span>
                  <span className="d-none d-md-block">
                    Urmonderbaan 22, 6167RD, Geleen, Netherlands
                  </span>
                </div>

                <Link
                  href="https://maps.app.goo.gl/7diubmi1UeKs6hDEA"
                  target="_blank"
                  className={clsx(
                    styles.contactPill,
                    "bg-clr-white gap-2 text-black p fw-medium d-flex align-items-center",
                  )}
                >
                  <span className={clsx(styles.pillIcon, "text-clr-blue")}>
                    {Icons.navigationArrow}
                  </span>
                  <span className="d-none d-md-block"> Get direction</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
